import { defineMessages } from 'react-intl';

export default defineMessages({
  noData: 'No data available for this asset',
});
